export default __webpack_public_path__ + "static/media/rural.f3397e3b.png";